import React, { useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'

import { UPDATE_AUDIO_VOLUME, usePlayer } from '../context/player-context'
import { VolumeSlider } from './volumeSlider'
import SimpleAudio from './reactAudio'
import AudioSlider from './audioSlider'
import Drawer from 'react-bottom-drawer'
import { useMedia } from 'react-use'
import { isiOS } from '../../../common/helpers/Mobile'
import { meditationSounds } from '../../../common/api/constants'
import { ROUTE_ACTIVITIES_MEDITATION_ALL } from '../../../common/helpers/Paths'

function AudioPlayer() {
  let location = useLocation()
  const history = useHistory()

  const { contextState, dispatch } = usePlayer()

  const [isEmpty, setIsEmpty] = useState(true)
  const [settingVolume, setSettingVolume] = useState(true)
  const [isVisible, setIsVisible] = useState(false)
  const [onceRender, setOnceRender] = useState(true)
  const isSmallScreen = useMedia('(max-width: 575px)')
  const isMediumScreen = useMedia('(min-width: 767px)')

  const backButton = isMediumScreen
    ? document.querySelector('.brand-container .nav-icon-link.left')
    : document.querySelector('.nav-icon-link.left')

  const handleRestartAudio = () => contextState.audioControls.seek(0)

  const handleDisplayVolumeControllers = () =>
    setIsVisible(prevState => !prevState)

  useEffect(() => {
    if (backButton && contextState.audio) {
      const handleBackButton = () => history.push(ROUTE_ACTIVITIES_MEDITATION_ALL, {
        sound: Object.keys(meditationSounds).find(
          key => meditationSounds[key] === contextState.audio.props.src
        ),
        volume: location.state.volume,
        duration: contextState.totalTime
      })

      backButton.addEventListener('click', handleBackButton)

      return () => backButton.removeEventListener('click', handleBackButton)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contextState.audio, backButton])

  useEffect(() => {
    isEmpty &&
      Object.keys(contextState.audioOptions).length &&
      setIsEmpty(false)
  }, [isEmpty, contextState.audioOptions])

  useEffect(() => {
    if (onceRender && contextState.audioControls) {
      const volume = location.state.volume / 100

      dispatch({
        type: UPDATE_AUDIO_VOLUME,
        payload: volume
      })

      if (contextState.audioControls && settingVolume) {
        contextState.audioControls.volume(volume)
        setSettingVolume(false)
      }

      setOnceRender(false)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location, contextState.audioControls])

  return (
    <>
      <SimpleAudio />
      {!isEmpty && (
        <main className='audio-slider-container--content pt-4 d-flex flex-column justify-content-around'>
          {/* Don't show audio volume control on iOS */}
          {!isiOS() && (
            <div className='audio-volume'>
              <button
                className='bg-transparent border-0 text-white fs-5'
                onClick={handleDisplayVolumeControllers}
              >
                <i className='bi bi-volume-up'></i>
              </button>
              {isSmallScreen ? (
                <Drawer
                  duration={250}
                  hideScrollbars={true}
                  closeOnOutsideClick={true}
                  onClose={() => setIsVisible(false)}
                  className='p-2'
                  isVisible={isVisible}
                >
                  <div className='audio-volume__drawer py-4 px-3'>
                    <VolumeSlider />
                    <button
                      type='button'
                      className='w-100 mt-5 btn btn-primary'
                      onClick={() => setIsVisible(false)}
                    >
                      Change
                    </button>
                  </div>
                </Drawer>
              ) : (
                isVisible && <VolumeSlider />
              )}
            </div>
          )}
          <AudioSlider />
          <div className='audio-slider--controls d-flex align-items-center justify-content-center'>
            <button className='restart-button' onClick={handleRestartAudio}>
              <i className='bi bi-arrow-counterclockwise'></i>
            </button>
            {contextState.audioOptions.playing ? (
              <button
                className='pause-button'
                onClick={contextState.audioControls.pause}
              >
                <i className='bi bi-pause'></i>
              </button>
            ) : (
              <button
                className='play-button'
                onClick={contextState.audioControls.play}
              >
                <i className='bi bi-play'></i>
              </button>
            )}
          </div>
        </main>
      )}
    </>
  )
}

export default AudioPlayer
